import { render, staticRenderFns } from "./LiquidacionesBackofficeDetalle.vue?vue&type=template&id=c87fb804&scoped=true&"
import script from "./LiquidacionesBackofficeDetalle.vue?vue&type=script&lang=js&"
export * from "./LiquidacionesBackofficeDetalle.vue?vue&type=script&lang=js&"
import style0 from "./LiquidacionesBackofficeDetalle.vue?vue&type=style&index=0&id=c87fb804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87fb804",
  null
  
)

export default component.exports